<script lang="ts">
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import { CustomContentTitleEntity } from "@shared/services/event_tracking/entities";
  import { EventTracking } from "@shared/services/event_tracking/events";

  export let description: string = null;
  export let header: string;
  export let displaySponsoredLabel: boolean = false;
  export let trackingData: any = {};

  // Unused props passed from discovery panel
  export let mobileMode = null;
  mobileMode;
  export let type: string | null = null;
  type;

  const { trackMrcEvents } = EventTracking;
  const trackingEntity: CustomContentTitleEntity = new CustomContentTitleEntity(trackingData);
</script>

<TrackingContext entities={trackingEntity} let:trackingContext>
  <div
    class="fizz-margin-auto fizz-text-center fizz-inset-stretch-24"
    style="max-width: 800px;"
    data-testid="title-component"
    use:trackMrcEvents={[trackingContext.entities]}
  >
    {#if displaySponsoredLabel}
      <div
        class="fizz-flex-row fizz-stack-8 fizz-justify-center"
        data-testid="title-sponsored-label"
      >
        <div class="fizz-text-small fizz-text-subdued">Sponsored</div>
      </div>
    {/if}
    <h1 class="fizz-stack-16 fizz-heading-1">
      {header}
    </h1>
    {#if description}
      <p
        data-testid="title-component-description"
        class="fizz-text-large fizz-margin-auto fizz-text-subdued"
      >
        {description}
      </p>
    {/if}
  </div>
</TrackingContext>
